import Chip from '@components/Chip';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';

import styles from './styles.module.scss';

interface Props {
    amount: number;
}

function CardAmount({ amount }:Props) {
  return (
        <Column spacing={22} fullWidth>
            <Text size='2xl' fontWeight='bold' color={colors.gray7}>
                구매금액
            </Text>
            <Chip.Container className={styles.amount}>
                <Chip isSelected>{amount / 10000}만원</Chip>
            </Chip.Container>
        </Column>
  );
}

export default CardAmount;
